import Image from 'next/image';
import styles from './IconButton.module.scss';
import React, { forwardRef } from 'react';

// TODO:CSS a lot has changed here, check it on the page
export const IconButton = forwardRef<
  HTMLButtonElement,
  {
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
    src: string;
    alt: string;
    outerClassName?: string;
    innerClassName?: string;
  } & React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ onClick, src, alt, outerClassName, innerClassName, ...rest }, ref) => (
  <button
    ref={ref}
    onClick={onClick}
    className={outerClassName}
    type={'button'}
    {...rest}
  >
    <div className={[styles.button, innerClassName].join(' ')}>
      <Image src={src} width={24} height={24} alt={alt} className={styles.icon} />
    </div>
  </button>
));

IconButton.displayName = 'IconButton';
